import { InvoiceRow } from '@numeo/types-core'
import { ExistingInvoiceBatchOption } from '../types/invoiceBatch'
import { canAppendToInvoiceBatch } from './invoiceBatch'
import { rowToGroupedBatch } from './invoiceRows'

export function rowsToExistingInvoiceBatchOptions(rows: InvoiceRow[]): ExistingInvoiceBatchOption[] {
    return rows
        .map(rowToGroupedBatch)
        .filter(canAppendToInvoiceBatch)
        .map((batch) => ({
            batchName: batch.batchName || '',
            totalLoads: batch.totalLoads,
            totalDue: batch.totalDue,
            invoiceCount: batch.invoices.length,
            updatedAt: batch.updatedAt,
        }))
        .filter((batch) => batch.batchName)
}
